import { Agentation } from 'agentation';

import { IS_PROD } from '@cast/constants';

import { useFeedbackToolbar } from './feedback-toolbar-state';

export const AgentationWrapper = () => {
  const hidden = useFeedbackToolbar((s) => s.hidden);

  if (hidden || IS_PROD) {
    return null;
  }

  return <Agentation />;
};
